exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon{width:1.2em;height:1.2em;fill:currentColor}.icon.is-large{width:2em;height:2em}.icon.is-medium{width:1.6em;height:1.6em}.icon.is-normal{width:1.2em;height:1.2em}.icon.is-small{width:1em;height:1em}.icon.is-tiny{width:.8em;height:.8em}.icon.is-blue,.icon.is-primary{fill:#2196f3}.icon.is-green,.icon.is-success{fill:#4caf50}.icon.is-danger,.icon.is-red{fill:#f44336}.icon.is-orange,.icon.is-warning{fill:#ff9800}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22f0ba5e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/components/app-icon.vue
// module id = 267
// module chunks = 0 1